import Aqi from './components/Aqi'
import Header from './components/Header';
import Footer from './components/Footer'

function App() {
  return (
    <div className="App">
     <Header/>
     <Aqi/>
     <Footer/>
    </div>
  );
}

export default App;
